module.exports = __webpack_public_path__ + "img/Glints.3d293aae.png";